import { SearchScopeType } from './search-scope-type';
import { PageRequest } from '../common/page-request';

/**
 * Search request API options.
 */
export class SearchRequest extends PageRequest {
    public schedule_id?: string;
    public min_score?: number;
    public position_id?: string;
    public end_at?: string;
    public start_at?: string;
    public type?: string;
    public q?: string;
    public scope?: SearchScopeType;
    public schedule_ids?: string[];
    public location_ids?: string[];
    public position_ids?: string[];
    public user_ids?: string[];
    public includes?: string[];

    constructor(
        scope: SearchScopeType,
        q?: string,
    ) {
        super();

        this.scope = scope;

        if (q) {
            this.q = q;
        }
    }
}
